module.exports = __webpack_public_path__ + "img/CersoNoVig.bd6fef5f.png";